import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AvailabilityProduct } from '../../../workflow/workflow.types';
import {TariffBankAccount, TariffFlatOffer, Tariff} from '../../../tariff/tariff.model';
import { AutorunComponent } from '@myshared/autorun.component';
import {tariffNameTranslationKey} from "@myshared/utils";

@Component({
  selector: 'app-tariff-select-variant',
  templateUrl: './tariff-select-variant.component.html',
  standalone: false
})
export class TariffSelectVariantComponent extends AutorunComponent {
  @Input() public currentPlan: string;
  @Input() public flatrates: Tariff[];

  @Output() public readonly fairFlatSelected = new EventEmitter<string>();
  @Output() public readonly fullFlatSelected = new EventEmitter<string>();
  @Output() public readonly back = new EventEmitter<void>();

  public readonly FAIR_FLATS = ['PC-ONE-TARIFF-FLAT-S', 'PC-ONE-TARIFF-FLAT-M', 'PC-ONE-TARIFF-FLAT-L', 'PC-ONE-TARIFF-FLAT-XL'];
  public readonly SMALLEST_FLAT = "PC-ONE-TARIFF-FLAT-S"
  public readonly FULL_FLAT = "PC-ONE-TARIFF-FLAT-FULL"

  constructor() {
    super(); 
  }

  onBack() { 
    this.back.emit();
  }

  public onFairFlatSelected() {
    this.fairFlatSelected.emit(this.SMALLEST_FLAT);
  }

  public onFullFlatSelected() {
    this.fullFlatSelected.emit(this.FULL_FLAT);
  }

  get fullFlatTariff() {
    return this.flatrates.find(l => l?.name === this.FULL_FLAT);
  }

  get smallestFairFlatTariff() {
    return this.flatrates.find(l => l?.name === this.SMALLEST_FLAT);
  }

  public getZoneTranslationKey(zoneName: string): string {
        return 'tariff_min_' + zoneName.replace('-', '_').toLowerCase();
  }
  
  public get displayName(): string {
        return tariffNameTranslationKey(this.smallestFairFlatTariff.name);
    }
}
